import { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Users, Share2, Gift, Sparkles } from 'lucide-react';

export default function Referral() {
  const [data, setData] = useState(null);
  const [applyCode, setApplyCode] = useState('');
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get('/referrals/my');
    setData(data);
  };
  useEffect(() => { load(); }, []);

  const share = () => {
    const url = `${window.location.origin}/?ref=${data?.code}`;
    navigator.clipboard?.writeText(url);
    toast.success('Lien de parrainage copié !');
  };

  const apply = async () => {
    if (!applyCode.trim() || busy) return;
    setBusy(true);
    try {
      const { data: res } = await api.post('/referrals/apply', { code: applyCode.trim().toUpperCase() });
      toast.success(`Code appliqué ! Parrainé par ${res.referrer_name || 'un ami'}`);
      setApplyCode('');
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erreur');
    } finally { setBusy(false); }
  };

  const url = data ? `${window.location.origin}/?ref=${data.code}` : '';

  return (
    <Layout>
      <div className="p-6 md:p-10 max-w-3xl">
        <div className="mb-10 rise text-center">
          <div className="overline text-orange-400 mb-2 flex items-center justify-center gap-2">
            <Gift size={14} /> Parrainage
          </div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-none">
            Invite un ami, <br />
            <em className="text-orange-500 not-italic">gagne un mois offert.</em>
          </h1>
          <p className="text-stone-400 mt-4 max-w-xl mx-auto">
            Chaque ami qui devient Pro grâce à ton lien te fait gagner <strong>+30 jours gratuits</strong>. Il en reçoit +30 aussi.
          </p>
        </div>

        <div className="card-stone p-6 mb-6">
          <div className="overline text-stone-500">Ton code</div>
          <div data-testid="referral-code" className="font-display text-4xl mt-1 text-orange-400">{data?.code || '...'}</div>
          <div className="text-stone-400 text-sm break-all mt-3">{url}</div>
          <button data-testid="referral-share" onClick={share} className="btn-primary mt-4 inline-flex items-center gap-2">
            <Share2 size={16} /> Copier mon lien
          </button>
        </div>

        <div className="grid grid-cols-3 gap-4 mb-8">
          <Stat testid="stat-invited" label="Invités" value={data?.invited_count || 0} />
          <Stat testid="stat-rewarded" label="Convertis en Pro" value={data?.rewarded_count || 0} />
          <Stat testid="stat-bonus" label="Jours gagnés" value={data?.bonus_days || 0} />
        </div>

        <div className="card-stone p-5">
          <div className="flex items-center gap-2 mb-3 text-stone-300">
            <Sparkles size={16} className="text-orange-400" />
            <div className="font-display text-xl">Tu as reçu un code d'un ami ?</div>
          </div>
          <div className="flex items-center gap-2">
            <input
              data-testid="referral-input"
              value={applyCode}
              onChange={e => setApplyCode(e.target.value.toUpperCase())}
              placeholder="MAExxxxxx"
              className="flex-1 px-3 py-2 rounded-full bg-stone-900 border border-stone-800 text-stone-100 focus:outline-none focus:border-orange-800"
            />
            <button data-testid="referral-apply" onClick={apply} disabled={busy} className="btn-ghost">Appliquer</button>
          </div>
          <div className="text-xs text-stone-500 mt-2">Utilise le code une fois pour lier ton compte à ton parrain.</div>
        </div>

        <div className="mt-8 text-center text-stone-500 text-sm inline-flex items-center gap-2">
          <Users size={14} /> Ensemble on apprend mieux · Merci de partager Maestro
        </div>
      </div>
    </Layout>
  );
}

function Stat({ testid, label, value }) {
  return (
    <div data-testid={testid} className="card-stone p-4 text-center">
      <div className="font-display text-3xl text-orange-400">{value}</div>
      <div className="text-stone-400 text-xs mt-1">{label}</div>
    </div>
  );
}
